export const stepConfig = [
  {target: '.AddButtonContainer', key: 'addLearners'},
  {target: '.FilterButtonWizard', key: 'filter'},
  {target: '[data-column-id="learner_status"]', key: 'status'},
  {target: '[data-column-id="course_actions"]', key: 'actions'},
  {target: 'button[aria-label="Expand Row"]', key: 'expandRow'},
];
